module.exports = __webpack_public_path__ + "media/images/flags/4x3/pri-6c89e3897c100d8c2f76e0a3ef610296.svg";